import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

import {
  LeftButton,
  LeftText,
  RightButton,
  RightText,
  Container,
  LoadingContainer,
} from './styles';

function SwitchOption({
  value,
  activeText = 'Ativo',
  inactiveText = 'Inativo',
  activeColor,
  inactiveColor,
  loading,
  disabled,
  ...props
}) {
  const isDisabled = disabled || loading;

  if (loading) {
    return (
      <Container>
        <LoadingContainer>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
          <span className="sr-only"> Loading...</span>
        </LoadingContainer>
      </Container>
    );
  }

  return (
    <Container>
      <LeftButton
        $active={value}
        $activeColor={activeColor}
        $inactiveColor={inactiveColor}
        disabled={isDisabled}
        {...props}
      >
        <LeftText type="label">{activeText}</LeftText>
      </LeftButton>
      <RightButton
        $active={value}
        $activeColor={activeColor}
        $inactiveColor={inactiveColor}
        disabled={isDisabled}
        {...props}
      >
        <RightText type="label">{inactiveText}</RightText>
      </RightButton>
    </Container>
  );
}

export default SwitchOption;
